import React, { useState, useEffect } from "react";
import logo from "./../images/Art_Of_Living_Logo.png";

const Topbar = () => {
  const [showTitle, setShowTitle] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 80) {
        setShowTitle(true);
      } else {
        setShowTitle(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div className="topbar">
      <a href="https://bangaloreashram.org/">
        <img src={logo} className="logo" alt="aol" />
      </a>
      <div
        className={`flex flex-col text-center mr-1 ${
          showTitle ? "fade-in active" : "fade-in"
        }`}
      >
        <div className="hidden sm:flex text-xl">Program Request Form</div>
        <div className="flex sm:hidden flex flex-col">
          <div className="text-lg">Program Request</div>
          <div className="text-sm">Form</div>
        </div>
      </div>
      <a href="https://bangaloreashram.org/" className="home-topbar">
        Home
      </a>
    </div>
  );
};

export default Topbar;
